<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="container-fluid">

            <div class="row">
                <div class="col-12 mb-4">
                    <v-card>
                        <v-card-title>
                            <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Rechercher ..."
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                                :headers="headers"
                                :items="ask_payoutsap"
                                :search="search"
                                sort-by="name"
                                class="elevation-1"
                                :loading="askcancelloading"
                                loading-text="Chargement en cours...">

                            <template v-slot:item.montant="{ item }">
                                <v-chip  dark>{{ item.montant +" FCFA" }}</v-chip>
                            </template>
                            <template v-slot:item.ask_time="{item}">
                                {{ getformatDate(item.ask_time)}}
                            </template>
                            <template  v-slot:item.actions="{ item }">
                                <div v-if='item.state_ask==="Demande refusée"'>
                                    <v-chip color="red" dark>Refusée</v-chip>

                                </div>
                                <div v-else-if='item.state_ask==="Retrait éffectué"'>
                                    <v-chip color="green" dark>Approuvée</v-chip>
                                </div>
                                <div v-else-if=' item.state_ask==="Demande confirmée, en attente de paiement"'>
                                    <v-chip color="#FFCC00" dark>En attende de paiement</v-chip>

                                </div>
                                <div v-else-if=' item.state_ask==="Annuler"'>

                                    <v-chip  color="#bb0b0b" dark>Annuler</v-chip>

                                </div>
                                <div v-else>

                                    <v-chip v-if="item.pharmacie_user_slug !==user._id"  color="#ccc" dark>En attente</v-chip>
                                    <v-btn v-else style="color: #fff" class="btn btn-danger" @click="deleteItem(item)" color="#bb0b0b">Annuler</v-btn>

                                </div>

                            </template>
                            <template v-slot:no-data>
                                <v-btn color="default" @click="initialize">Actualiser</v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </div>
            <v-snackbar
                    v-model="snackbar"
                    timeout="2000"
            >
                {{ textSnack }}

                <template v-slot:action="{ attrs }">
                    <v-btn
                            color="blue"
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                    >
                        Fermer
                    </v-btn>
                </template>
            </v-snackbar>

        </div> <!-- container-fluid -->
    </div>
    <!-- End Page-content -->

</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "AskPayout",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                tabs: null,
                dialog: '',
                user: JSON.parse(localStorage.getItem("user")),
                id: undefined,
                snackbar: false,
                textSnack: '',
                headers: [
                    {text: 'Commentaire', value: 'comment'},

                    {
                        text: 'Montant',
                        align: 'start',
                        sortable: true,
                        value: 'montant',
                    },
                    {text: 'Numéro de retrait', value: 'phone_receiver'},
                    {text: 'Etat', value: 'state_ask'},
                    {text: 'Avis admin', value: 'comment_ask_admin'},
                    {text: 'Date de demande', value: 'ask_time'},

                    {text: 'Actions', value: 'actions', sortable: false},


                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                commentRules: [
                    v => !!v || 'Comment requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                montantRules: [
                    v => !!v || 'Montant requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                phoneRules: [
                    v => !!v || 'Numéro de retrait  requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],



            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle demande" : "Mise à jour"
            }
            ,
            ...mapState('ask_payouts/', ['ask_payoutsap','askcancelloading']),
            ...mapState('balance/', ['balance'])


        }
        ,
        mounted() {
            let user = JSON.parse(localStorage.getItem("user"));
            console.log("User local2");
            console.log(user);
            this.$store.dispatch('ask_payouts/getAsk_payoutOneA',user.relation._id).then(response => {
                window.console.log('ask_payouts', response)
            });
            this.$store.dispatch('balance/get',user.relation._id).then(response => {
                window.console.log('user', response)
            });


        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.ask_payoutsap.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir anuuler cette demande ?",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('ask_payouts/annuleAsk_payout', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            });
                            let user=JSON.parse(localStorage.getItem("user"));
                            this.$store.dispatch('ask_payouts/getAsk_payoutOneA',user.relation._id).then(response => {
                                window.console.log('ask_payouts', response)
                            });
                        })
                    }
                })
            },
            close() {
                this.$refs.form.reset()
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.dialog = false;

            },
            save() {
                this.submitting = true;
                let user=JSON.parse(localStorage.getItem("user"));
                let data = new FormData();
                data.append("montant", this.editedItem.montant);
                data.append("phone_receiver", this.editedItem.phone_receiver);
                data.append("comment", this.editedItem.comment);
                if (this.balance) {
                    data.append("balance_now", this.balance.amount);
                }
                data.append("pharmacie_slug", user.relation._id);
                data.append("pharmacie_user_slug", user._id);
                let mineroute = 'ask_payouts/setAsk_payout';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'ask_payouts/setAsk_payout';
                }
                console.log("ELE");

                console.log(this.editedItem);
                if (this.balance) {
                    let demande=0;

                    for (let i=0; i<this.ask_payoutsap.length; i++) {
                        if (this.ask_payoutsap[i].state_ask !=="Retrait éffectué" && this.ask_payoutsap[i].state_ask !=="Demande refusée" && this.ask_payoutsap[i].state_ask !=="Annuler"){
                            demande=demande+this.ask_payoutsap[i].montant
                        }
                    }

                    let demandes=parseFloat(this.editedItem.montant)+demande;
                    console.log('Demande'+demandes)

                    if (this.editedItem.montant>this.balance.amount){
                        this.snackbar = true;
                        this.textSnack = "Votre solde est insuffisant";
                        this.submitting = false;


                    }else if(demandes>this.balance.amount){
                        this.snackbar = true;
                        this.textSnack = "Vos demandes en cours et la nouvelle ne couvrent pas votre solde";
                        this.submitting = false;

                    }else if(this.editedItem.montant<10000){
                        this.snackbar = true;
                        this.textSnack = "Montant minimum de retrait insuffisant";
                        this.submitting = false;
                    }
                    else{
                        this.$store.dispatch(mineroute, data).then((response) => {
                            console.log('response', response);
                            this.snackbar = true;
                            this.textSnack = response.data.message;
                            this.submitting = false;
                            if (response.error) {
                                this.errors.operation = response.data.message;
                            } else {
                                this.close();
                            }
                        })

                    }
                }else {
                    this.snackbar = true;
                    this.textSnack = "Votre solde est vide";
                    this.submitting = false;
                }


            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>